<template>
  <div class="assigned-input">
    <project-select v-if="mounted" class="es-simple" v-model="model" />
    <div v-if="model" @click="unassign" class="unassign"><a>Desatribuir</a></div>
  </div>
</template>

<script>
import TaskMixin from "components/suporte/components/task/include/TaskMixin"
import {updateTask} from "@/domain/tarefas/services"
import ProjectSelect from "components/suporte/components/projetos/include/ProjectSelect"

export default {
  name: "ProjectEdit",
  data () {
    return {
      model: null,
      bind: false,
      mounted: true
    }
  },
  computed: {
    entity () {
      return this.task.project
    }
  },
  mounted() {
    this.model = this.task.project
    this.$nextTick(() => {
      this.bind = true
    })
  },
  watch: {
    model (v) {
      this.bind && this.change(v)
    }
  },
  methods: {
    set (v) {
      this.task.project = v
    },
    reset (v) {
      this.bind = false
      this.mounted = false
      this.$nextTick(() => {
        this.model = v
        this.set(v)
        this.$nextTick(() => {
          this.bind = true
          this.mounted = true
        })
      })
    },
    change (v) {
      const old = this.entity
      this.$uloc.dialog({
        title: 'Confirmar alteração do projeto',
        message: 'Alterar projeto da tarefa para ' + v.name + '?',
        ok: 'Alterar projeto',
        cancel: 'Cancelar',
        color: 'black',
        noCaps: true
      }).then(() => {
        this.confirmUpdate(v)
      })
          .catch(() => {
            this.reset(old)
          })
    },
    confirmUpdate (project) {
      const old = this.entity
      this.loading = true
      updateTask({
        id: this.task.id,
        project: project ? project.id : null
      }, 'PATCH')
          .then(response => {
            this.loading = false
            this.$emit('update', project)
          })
          .catch(error => {
            this.loading = false
            this.set(old)
            this.model = old
            this.alertApiError(error)
          })
      if (!project) {
        this.mounted = false
        this.bind = false
        this.$nextTick(() => {
          this.model = null
          this.$nextTick(() => {
            this.mounted = true
          })
        })
      }
      this.set(project)
    },
    unassign () {
      this.$uloc.dialog({
        title: 'Confirmar remoção de projeto',
        message: 'Remover projeto para esta tarefa?',
        ok: 'Remover projeto',
        cancel: 'Cancelar',
        color: 'black',
        noCaps: true
      }).then(() => {
        this.confirmUpdate(null)
      })
          .catch(() => {})
    }
  },
  components: {ProjectSelect},
  mixins: [TaskMixin]
}
</script>
